module.exports = __webpack_public_path__ + "static/media/getting-support-large.d5748e5a.png";